<script type="text/javascript">
// API 模块统一导出（向后兼容）
// 此文件已重构为从模块化 API 文件导入并重新导出
// 新增功能请添加到 /src/api/ 目录下的相应模块文件中

import api from "./api/index";

export default api;
</script>
